import styled from 'styled-components';
import DropDown from '@/trio-ui/Dropdown';
import TagSelector from '@/trio-ui/TagSelector';
import TransparentButton from '@/trio-ui/TransparentButton';

export const CustomTagSelector = styled(TagSelector)`
  margin: 0;
`;

export const CustomDropDown = styled(DropDown)`
  margin-bottom: 0px !important;

  label {
    white-space: nowrap;
  }
`;

export const WorkingTimesBox = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const DoubleInputRow = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-bottom: 20px;
  gap: 12px;
  width: 50%;

  > label {
    text-align: right;
    font-size: 14px;
    flex: 1 1 0%;
    display: block;
    line-height: 21px;
    min-height: 21px;
    color: rgb(111, 113, 117);
    line-height: 34px;
  }

  & > div {
    width: 50%;
    display: flex;
    justify-content: space-between;

    & > div {
      width: calc(50% - 11px);
      display: flex;
      align-items: flex-start;
    }

    & > span {
      flex-shrink: 0;
      line-height: 34px;
    }

    & > div > div {
      width: 100%;
    }
  }
`;

export const WorkingTimesInputRow = styled(DoubleInputRow)`
  width: 100%;

  &:not(&:last-of-type) {
    margin-bottom: 8px;
  }
`;

export const CustomTransparentButton = styled(TransparentButton)`
  margin-top: -12px;
  width: 50%;
`;

export const InputWrapper = styled.div`
  margin-bottom: 20px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 50%;
  }
`;

export const Form = styled.form``;

export const FormGroup = styled.div`
  &:not(&:last-child) {
    border-bottom: 1px solid;
    border-color: ${(props) => props.theme.colors['neutral-30']};
    padding-bottom: 12px;
  }
  &:not(&:first-child) {
    padding-top: 32px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
`;
